import React, { Component } from 'react';
import { API_BASE_URL } from "../../constants";
import { validateComponent, validateField } from "../../common/validation";
import { deepCopyObject, showAxiosError, trimObject } from "../../util/Helpers";
import { request } from "../../util/APIUtils";
import LoadingIndicator from "../../common/LoadingIndicator";
import { UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import { message } from 'antd';

class JobPostingForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            model: "create",
            page: 0,
            size: 10,
            manual: false,
            isLoading: false,
            fieldsDisabled: false,
            jobPosting: {
                jobTitle: "",
                jobDescription: "",
                postedDate: "",
                expiryDate: "",
                contactInfo: "",
                eczane: {
                    id: ""
                }
            },
            pharmacies: [] // Düzeltilmiş state adı
        };
    }

    componentDidMount() {
        if (this.props.jobPosting) {
            this.setState({
                jobPosting: this.props.jobPosting,
            });
        }
        this.fetchPharmacies(); // Eczane verilerini çekmek için çağrı
    }

    fetchPharmacies = () => {
        request({
            url: API_BASE_URL + "/pharmacies/allPharmacy",
            method: 'GET',
        }).then(response => {
            console.log('Pharmacies response:', response); // Gelen yanıtı kontrol edin
            // Yanıtın doğru formatta olup olmadığını kontrol edin ve eczane adlarını alın
            const pharmacyNames = response.data.map(eczane => ({
                id: eczane.id,
                name: eczane.name
            }));
            this.setState({ pharmacies: pharmacyNames });
        }).catch(error => {
            showAxiosError(error);
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.jobPosting && prevProps.jobPosting !== this.props.jobPosting) {
            this.setState({
                jobPosting: this.props.jobPosting,
            });
        }
    }

    validateClass = (id) => {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage = (id) => {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent = () => {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result;
    }

    validateField = (e) => {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, { [id]: result });
        this.setState({ error });
    }

    onChangeJobPosting = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'eczane') {
            this.setState({
                jobPosting: {
                    ...this.state.jobPosting,
                    eczane: {
                        id: value
                    }
                }
            });
        } else {
            this.setState({
                jobPosting: {
                    ...this.state.jobPosting,
                    [name]: value
                }
            });
        }
    }

    saveJobPosting = () => {
        let self = this;
        let params;
        let data;
        let messageContent;
        let token = localStorage.getItem("accessToken");

        self.setState({ isLoading: true });
        let jobPosting = deepCopyObject(this.state.jobPosting);
        jobPosting = trimObject(jobPosting);
        data = jobPosting;

        jobPosting.postedDate = moment(jobPosting.postedDate).format('YYYY-MM-DDTHH:mm:ss');
        jobPosting.expiryDate = moment(jobPosting.expiryDate).format('YYYY-MM-DDTHH:mm:ss');

        if (jobPosting.id === null || jobPosting.id === undefined) {
            messageContent = 'İş İlanı Başarıyla Oluşturuldu.';
            params = {
                url: API_BASE_URL + "/jobPosting/saveJob/",
                data: data,
                method: 'post',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        } else {
            messageContent = 'İş İlanı Başarıyla Güncellendi.';
            params = {
                url: API_BASE_URL + "/jobPosting/" + jobPosting.id,
                data: data,
                method: 'put',
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
            };
        }

        request(params).then(() => {
            message.success(messageContent, 5); // 5 saniye boyunca gösterilecek
            self.setState({ isLoading: false });
            this.cancelProcess();
            self.props.handleSearch(self.props.searchQuery, true);
        }).catch(function (error) {
            self.setState({ isLoading: false });
            showAxiosError(error);
        });
    }

    cancelProcess = () => {
        this.props.cancelProcess();
    }

    handleLogout = () => {
        this.props.handleLogout();
    }

    render() {
        const { jobPosting, pharmacies } = this.state;

        return (
            <div className="jobPosting-form-container" style={{ width: "100%" }}>
                {this.state.isLoading &&
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                }
                <div className="card-body mt-1" style={{ width: "100%" }}>
                    <div className="formRenk col-sm-12 mt-4">
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>Görev Adı </label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tJobTitle')}>
                                    <input className="form-control"
                                        type="text"
                                        name="jobTitle"
                                        id="tJobTitle"
                                        data-vlength="1,255"
                                        onBlur={this.validateField}
                                        value={jobPosting.jobTitle || ""}
                                        onChange={this.onChangeJobPosting}
                                        disabled={this.state.fieldsDisabled}
                                    />
                                    {this.validateMessage('tJobTitle') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tJobTitle" delay={0}>
                                            {this.validateMessage("tJobTitle")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>Görev Başlığı</label>
                            </div>

                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tJobDescription')}>
                                    <input className="form-control"
                                        type="text"
                                        name="jobDescription"
                                        id="tJobDescription"
                                        data-vlength="1,255"
                                        onBlur={this.validateField}
                                        value={jobPosting.jobDescription || ""}
                                        onChange={this.onChangeJobPosting}
                                        disabled={this.state.fieldsDisabled}
                                    />
                                    {this.validateMessage('tJobDescription') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tJobDescription" delay={0}>
                                            {this.validateMessage("tJobDescription")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>İlan Açılış Tarihi</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tPostedDate')}>
                                    <input className="form-control"
                                        type="date"
                                        name="postedDate"
                                        id="tPostedDate"
                                        data-vlength="1,255"
                                        onBlur={this.validateField}
                                        value={jobPosting.postedDate ? moment.utc(jobPosting.postedDate).format('YYYY-MM-DD') : ''}
                                        onChange={this.onChangeJobPosting}
                                        disabled={this.state.fieldsDisabled}
                                    />
                                    {this.validateMessage('tPostedDate') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tPostedDate" delay={0}>
                                            {this.validateMessage("tPostedDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>İlan Kapanış Tarihi</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tExpiryDate')}>
                                    <input className="form-control"
                                        type="date"
                                        name="expiryDate"
                                        id="tExpiryDate"
                                        data-vlength="1,255"
                                        onBlur={this.validateField}
                                        value={jobPosting.expiryDate ? moment.utc(jobPosting.expiryDate).format('YYYY-MM-DD') : ''}
                                        onChange={this.onChangeJobPosting}
                                        disabled={this.state.fieldsDisabled}
                                    />
                                    {this.validateMessage('tExpiryDate') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tExpiryDate" delay={0}>
                                            {this.validateMessage("tExpiryDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>İletişim Adresi</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tContactInfo')}>
                                    <input className="form-control"
                                        type="text"
                                        name="contactInfo"
                                        id="tContactInfo"
                                        data-vlength="1,255"
                                        onBlur={this.validateField}
                                        value={jobPosting.contactInfo || ""}
                                        onChange={this.onChangeJobPosting}
                                        disabled={this.state.fieldsDisabled}
                                    />
                                    {this.validateMessage('tContactInfo') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tContactInfo" delay={0}>
                                            {this.validateMessage("tContactInfo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-3">
                                <label>İlanı Oluşturan Eczane</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tPharmacy')}>
                                    <select
                                        className="form-control"
                                        name="eczane"
                                        id="tPharmacy"
                                        onChange={this.onChangeJobPosting}
                                        value={jobPosting.eczane.id || ""}
                                        disabled={this.state.fieldsDisabled}
                                    >
                                        <option value="">Eczane Seçiniz...</option>
                                        {pharmacies.map(eczane => (
                                            <option key={eczane.id} value={eczane.id}>
                                                {eczane.name}
                                            </option>
                                        ))}
                                    </select>
                                    {this.validateMessage('tPharmacy') !== "" &&
                                        <UncontrolledTooltip placement="right" target="tPharmacy" delay={0}>
                                            {this.validateMessage("tPharmacy")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                style={{ background: '#9e9e9e', padding: '10px 54px 10px 23px', width: "150px" }}
                                rel="tooltip" className="TekBtn vazgec "
                                onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8" />
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                    float: 'right', padding: '10px 54px 10px 23px', width: "150px"
                                }}
                                rel="tooltip" className="TekBtn kaydet"
                                disabled={this.state.fieldsDisabled}
                                onClick={this.saveJobPosting}>{this.state.model === 'create' ? 'Onayla' : 'Kaydet'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default JobPostingForm;











// WEBPACK FOOTER //
// ./src/page/jobPosting/JobPostingForm.js